import { Pipe, PipeTransform } from '@angular/core';
import { Leave } from 'src/app/classes/leave';

@Pipe({
    name: 'leaveRepeatDays',
    standalone: false,
})
export class LeaveRepeatDaysPipe implements PipeTransform {
    transform(leave: Leave): string {
        const workdays =
            leave.repeat_monday &&
            leave.repeat_tuesday &&
            leave.repeat_wednesday &&
            leave.repeat_thursday &&
            leave.repeat_friday;
        const weekend = leave.repeat_saturday && leave.repeat_sunday;

        if (workdays && weekend) {
            return 'hele week';
        }

        const days = [
            !workdays && leave.repeat_monday ? 'maandag' : null,
            !workdays && leave.repeat_tuesday ? 'dinsdag' : null,
            !workdays && leave.repeat_wednesday ? 'woensdag' : null,
            !workdays && leave.repeat_thursday ? 'donderdag' : null,
            !workdays && leave.repeat_friday ? 'vrijdag' : null,
            workdays ? 'werkdagen' : null,
            !weekend && leave.repeat_saturday ? 'zaterdag' : null,
            !weekend && leave.repeat_sunday ? 'zondag' : null,
            weekend ? 'weekend' : null,
        ];

        return days.filter(Boolean).join(', ');
    }
}
